
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppButton } from '@/components';
import { useRfmGroup } from '@/modules/rfm/group/model/edit';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';

export default defineComponent({
    name: ROUTE_NAME_RFM.GROUP.ADD,
    components: { AppFormRow, AppInput, AppCard, AppButton },
    setup() {
        const { model, v$, actions } = useRfmGroup();

        return { v$, model, actions };
    }
});
